module.exports = __webpack_public_path__ + "img/cooking.0e1b0c6c.png";